import w from '@store/window';

class WebGLUtils {
    static isWebGLAvailable() {
        try {
            const canvas = document.createElement( 'canvas' );

            return !! ( w.WebGLRenderingContext && ( canvas.getContext( 'webgl' ) || canvas.getContext( 'experimental-webgl' ) ) );
        } catch ( e ) {
            return false;
        }
    }

    static getWebGLErrorMessage() {
        return WebGLUtils.getErrorMessage( 1 )
    }

    static getErrorMessage( version: number ): HTMLDivElement {

        var names: { [key: number]: any } = {
            1: 'WebGL',
            2: 'WebGL 2'
        };

        var contexts: { [key: number]: any } = {
            1: w.WebGLRenderingContext,
            2: w.WebGL2RenderingContext
        };

        var message = 'This sites uses $1 for rendering.<br/>Your $0 does not seem to support <a href="https://get.webgl.org/get-a-webgl-implementation/" style="color:#000">$1</a>';

        var element = document.createElement( 'div' );
        element.id = 'webglmessage';
        element.style.fontFamily = 'monospace';
        element.style.fontSize = '13px';
        element.style.fontWeight = 'normal';
        element.style.textAlign = 'center';
        element.style.background = '#fff';
        element.style.color = '#000';
        element.style.padding = '1.5em';
        element.style.width = '400px';
        element.style.margin = '5em auto 0';

        if (contexts[version]) {
            message = message.replace( '$0', 'graphics card' );
        } else {
            message = message.replace( '$0', 'browser' );
        }
        message = message.replace( /\$1/g, names[ version ] );
        element.innerHTML = message;
        return element;
    }
}

export default WebGLUtils;


// WEBPACK FOOTER //
// ./src/utils/WebGLUtils.tsx